/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { Label as RadixUiDropdownMenuLabel } from "@radix-ui/react-dropdown-menu";
import type { ComponentProps } from "react";

import { numericPixels, spacing } from "../../../../../global/emotion";
import { Text } from "../../_core/Text/Text.emotion";

const baseStyle: Interpolation = {
  alignItems: "center",
  display: "flex",
  height: numericPixels[56],
  justifyContent: "center",
  minWidth: numericPixels[300],
  padding: spacing.m,
  width: spacing.full,
};

export type DropdownMenuHeaderProps = ComponentProps<
  typeof RadixUiDropdownMenuLabel
>;

export const DropdownMenuHeader = ({
  children,
  ...props
}: DropdownMenuHeaderProps) => {
  return (
    <Text key={`dropdown-menu-header`} asChild size="m" type="title">
      <RadixUiDropdownMenuLabel
        key={`dropdown-menu-header`}
        css={baseStyle}
        {...props}
      >
        {children}
      </RadixUiDropdownMenuLabel>
    </Text>
  );
};
